<template>
  <div class="drawer">
    <el-drawer
      size="1500px"
      title="设置门店业绩目标"
      :visible.sync="drawerStatus"
      @close="handleClose"
    >
      <div style="padding-bottom: 40px">
        <el-row class="row">
          <el-col :span="24">
            <span class="label" style="vertical-align: middle">所选月份：</span>
            <span class="value" style="vertical-align: middle">
              {{ monthName }}
            </span>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="24">
            <span class="label" style="vertical-align: middle"
              >设置周数计算值：</span
            >
            <span class="value" style="vertical-align: text-top">
              <div style="margin-left: 10px">
                <div
                  v-for="(week, index) in datas.weekSettingList"
                  :key="index"
                  style="margin-bottom: 10px"
                > 
                  {{ week.weekName }}:
                  <el-date-picker
                    v-model="week.datePickerValue"
                    type="daterange"
                    range-separator="至"
                    @change="changeDatePickerValue(index,week)"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    size="mini"
                    format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                  <img
                    v-if="datas.weekSettingList.length === index + 1"
                    style="
                      width: 20px;
                      height: 20px;
                      vertical-align: middle;
                      margin: 4px;
                      cursor: pointer;
                    "
                    @click="jia"
                    src="../../../assets/img/shuju/jia.png"
                  />
                  <img
                    v-if="
                      datas.weekSettingList.length === index + 1 &&
                      datas.weekSettingList.length > 1
                    "
                    style="
                      width: 20px;
                      height: 20px;
                      vertical-align: middle;
                      margin: 4px;
                      cursor: pointer;
                    "
                    @click="jian"
                    src="../../../assets/img/shuju/jian.png"
                  />
                </div>
              </div>
            </span>
          </el-col>
        </el-row>

        <el-row class="row">
          <el-col :span="24">
            <span class="label">门店流水月目标：</span>

            <span class="value">
              <div class="cell1">
                <div
                  :class="{ active: tab == index }"
                  v-for="(item, index) in  datas.shopSettingList"
                  :key="index"
                  @click="shopClick(index)"
                >
                  {{ item.shopName }}
                </div>
              </div>
              <div class="table" v-if="tab == 0">
                <div class="tableRow">
                  <div class="cell">门店</div>
                  <div class="cell">本月业绩目标</div>
                  <div
                    class="cell"
                    v-for="(item, index) in datas.weekSettingList"
                    :key="index"
                  >
                    {{ item.weekName }}
                  </div>
                </div>

                <div
                  class="tableRow"
                  v-for="(shop, indexBig) in typeList"
                  :key="indexBig"
                >
                  <div class="cell">
                    {{ shop.typeName }}
                  </div>
                  <div class="cell">
                    <input
                      v-model.number="
                        weekData[tab].shopMonthSetting[typeListValue[indexBig]]
                      "
                  
                      style="
                        width: 70px;
                        height: 20px;
                        border-radius: 5px;
                        border: 1px solid #dcdfe6;
                      "
                      class="week"
                    />
                  </div>

                  <div
                    class="cell"
                    v-for="(item, index) in datas.weekSettingList"
                    :key="index"
                  >
                    <input
                      type="text"
                      v-model.number="
                        weekData[tab].shopWeekSetting[index][
                          typeListValue[indexBig]
                        ]
                      "
                      style="
                        width: 70px;
                        height: 20px;
                        border-radius: 5px;
                        border: 1px solid #dcdfe6;
                      "
                      class="week"
                    />
                  </div>
                </div>
              </div>
              <div class="table" v-if="tab == 1">
                <div class="tableRow">
                  <div class="cell">门店</div>
                  <div class="cell">本月业绩目标</div>
                  <div
                    class="cell"
                    v-for="(item, index) in datas.weekSettingList"
                    :key="index"
                  >
                    {{ item.weekName }}
                  </div>
                </div>

                <div
                  class="tableRow"
                  v-for="(shop, indexBig) in typeList"
                  :key="indexBig"
                >
                  <div class="cell">
                    {{ shop.typeName }}
                  </div>
                  <div class="cell">
                    <input
                      v-if="weekData"
                      v-model.number="
                        weekData[tab].shopMonthSetting[typeListValue[indexBig]]
                      "
                  
                      style="
                        width: 70px;
                        height: 20px;
                        border-radius: 5px;
                        border: 1px solid #dcdfe6;
                      "
                      class="week"
                    />
                  </div>

                  <div
                    class="cell"
                    v-for="(item, index) in datas.weekSettingList"
                    :key="index"
                  >
                    <input
                      type="text"
                      v-if="weekData"
                      v-model.number="
                        weekData[tab].shopWeekSetting[index][
                          typeListValue[indexBig]
                        ]
                      "
                      style="
                        width: 70px;
                        height: 20px;
                        border-radius: 5px;
                        border: 1px solid #dcdfe6;
                      "
                      class="week"
                    />
                  </div>
                </div>
              </div>
              <div class="table" v-if="tab == 2">
                <div class="tableRow">
                  <div class="cell">门店</div>
                  <div class="cell">本月业绩目标</div>
                  <div
                    class="cell"
                    v-for="(item, index) in datas.weekSettingList"
                    :key="index"
                  >
                    {{ item.weekName }}
                  </div>
                </div>

                <div
                  class="tableRow"
                  v-for="(shop, indexBig) in typeList"
                  :key="indexBig"
                >
                  <div class="cell">
                    {{ shop.typeName }}
                  </div>
                  <div class="cell">
                    <input
                      v-if="weekData"
                      v-model.number="
                        weekData[tab].shopMonthSetting[typeListValue[indexBig]]
                      "
                
                      style="
                        width: 70px;
                        height: 20px;
                        border-radius: 5px;
                        border: 1px solid #dcdfe6;
                      "
                      class="week"
                    />
                  </div>

                  <div
                    class="cell"
                    v-for="(item, index) in datas.weekSettingList"
                    :key="index"
                  >
                    <input
                      type="text"
                      v-if="weekData"
                      v-model.number="
                        weekData[tab].shopWeekSetting[index][
                          typeListValue[indexBig]
                        ]
                      "
                      style="
                        width: 70px;
                        height: 20px;
                        border-radius: 5px;
                        border: 1px solid #dcdfe6;
                      "
                      class="week"
                    />
                  </div>
                </div>
              </div>
              <div class="table" v-if="tab == 3">
                <div class="tableRow">
                  <div class="cell">门店</div>
                  <div class="cell">本月业绩目标</div>
                  <div
                    class="cell"
                    v-for="(item, index) in datas.weekSettingList"
                    :key="index"
                  >
                    {{ item.weekName }}
                  </div>
                </div>

                <div
                  class="tableRow"
                  v-for="(shop, indexBig) in typeList"
                  :key="indexBig"
                >
                  <div class="cell">
                    {{ shop.typeName }}
                  </div>
                  <div class="cell">
                    <input
                      v-if="weekData"
                      v-model.number="
                        weekData[tab].shopMonthSetting[typeListValue[indexBig]]
                      "
                      placeholder="请输入内容"
                      style="
                        width: 70px;
                        height: 20px;
                        border-radius: 5px;
                        border: 1px solid #dcdfe6;
                      "
                      class="week"
                    />
                  </div>

                  <div
                    class="cell"
                    v-for="(item, index) in datas.weekSettingList"
                    :key="index"
                  >
                    <input
                      v-if="weekData"
                      type="text"
                      v-model.number="
                        weekData[tab].shopWeekSetting[index][
                          typeListValue[indexBig]
                        ]
                      "
                      style="
                        width: 70px;
                        height: 20px;
                        border-radius: 5px;
                        border: 1px solid #dcdfe6;
                      "
                      class="week"
                    />
                  </div>
                </div>
              </div>
            </span>
          </el-col>
        </el-row>

        <div style="height: 40px; width: 100%"></div>
        <div class="btnBox">
          <div class="btnItem" @click="handleClose">取消</div>
          <div class="btnItem submit" @click="submit_check">确定</div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      //周目标
      week_target_list: [],
      week_list: [],
      week_value: [],
      weekValue: [],
      arr: [],
      drawerStatus: true,
      monthName: this.$public.FTime(sessionStorage.getItem("pkMonth"),"YYYY-MM"),
      typeList: [
        { id: 1, typeName: "活体销售业绩" },
        { id: 2, typeName: "商品销售业绩" },
        { id: 3, typeName: "医疗服务业绩" },
        { id: 4, typeName: "洗美服务业绩" },
        { id: 5, typeName: "销售总额" },
        { id: 6, typeName: "活体销售数量" },
      ],
      typeListValue: [
        "salePetMoney",
        "saleGoodsMoney",
        "saleMedicalMoney",
        "saleWashMoney",
        "saleMoney",
        "salePetCount",
      ],
      weekData: [],
      tab: 0,
      active: "active",
      // shopOptions: [
      //   {
      //     value: "5e9412e0b2bfbc089daerr12",
      //     label: "金水区店",
      //   },
      //   {
      //     value: "5e9412e0b2bfbc089daerr16",
      //     label: "拓展部",
      //   },
      //   {
      //     value: "5e9412e0b2bfbc089daerr18",
      //     label: "郑东新区店",
      //   },
      // ],
      datas: {
        shopSettingList: [{}],
        weekSettingList: [
          {
            weekName: "第一周",
            datePickerValue: ["", ""],
            week_name: "",
            begin_time: "",
            end_time: "",
            weekTarget: [],
          },
        ],
      },
    };
  },
  computed: {},
  props: {},

  mounted() {
   
    console.log(this.$public.FTime(sessionStorage.getItem("pkMonth"),"YYYY-MM"),']]]');
    this.getSetting();
  },

  updated() {
    this.$nextTick(() => {
      let weeks = document.getElementsByClassName("week");
      this.week_list = Array.prototype.slice.call(weeks);
      console.log(this.week_list,"000");
      if (this.weekValue.length) {
        if (this.weekValue.length == this.week_list.length) {
          for (let i = 0; i < this.weekValue.length; i++) {
            this.week_list[i].value = this.weekValue[i];
          }
        }
      }
    });
  },
  methods: {
    shopClick: function (index) {
      this.tab = index;
      console.log(index, this.tab);
    },

    handleClose() {
      this.$emit("submit", { type: "close" });
    },
    submit_check() {
      console.log(this.datas.weekSettingList,'this.datas.weekSettingList');
      let weekSettingList = [];
      for (let i = 0; i < this.datas.weekSettingList.length; i++) {
        console.log((this.datas.weekSettingList[i]),'00');
        weekSettingList.push({
          weekName: this.datas.weekSettingList[i].weekName,
          beginTime:moment((this.datas.weekSettingList[i].datePickerValue[0])).format("YYYY-MM-DD"),
          endTime:moment((this.datas.weekSettingList[i].datePickerValue[1])).format("YYYY-MM-DD"),
        });
        console.log(weekSettingList,"beginTime");
      }
      for (let i = 0; i < this.week_list.length; i++) {
        if (this.week_list[i].value == "") {
          this.$message({
            message: "周目标不能为空",
            type: "error",
          });
          return;
        }
      }
  console.log(this.weekData);
      let params = {
        monthName: this.$public.FTime(sessionStorage.getItem("pkMonth"),"YYYY-MM"),
        weekSettingList: weekSettingList,
        shopSettingList: this.weekData,
      };
      
      this.$http
        .post(
          process.env.VUE_APP_zichan + "/api/Performance/GetShopTarget",
          params
        )
        .then((res) => {
          if (res.code == 0) {
            this.$message({
              message: "设置成功",
              type: "success",
            });
            this.$emit("submit", { type: "success" });
          }
        });
    },
    getSetting() {
      let loading = this.$loading();
      let params = {
        month: this.$public.FTime(sessionStorage.getItem("pkMonth"), "YYYY-MM"),
      };
      this.$http
        .get(
          process.env.VUE_APP_zichan + "/api/Performance/GetShopTarget",
          params
        )
        .then((res) => {
          loading.close();
          this.drawerStatus = true;

          if (res.code == 0) {
            let datas = res.data;
            console.log("11111月目标信息", res.data);
            if (datas.weekSettingList.length === 0) {
              console.log("进入上面了");
              datas.weekSettingList.push({
                weekName: "第一周",
                datePickerValue: ["", ""],
                week_name: "",
                begin_time: "",
                end_time: "",
              });
              for (let index = 0; index < 1; index++) {
                this.weekData.push({
                  shopId:'5e9412e0b2bfbc089daerr18',
                  shopName:'郑东新区',
                  shopMonthSetting: {
                    salePetMoney: "",
                    saleGoodsMoney: "",
                    saleMedicalMoney: "",
                    saleWashMoney: "",
                    saleMoney: "",
                    salePetCount: "",
                  },
                  shopWeekSetting: [
                    {
                      salePetMoney: "",
                      saleGoodsMoney: "",
                      saleMedicalMoney: "",
                      saleWashMoney: "",
                      saleMoney: "",
                      salePetCount: "",
                    },
                  ],
                });
              }
            } else {
              for (let i = 0; i < datas.weekSettingList.length; i++) {
                console.log(datas.weekSettingList[i].beginTime,"datas.weekSettingList[i].beginTime");
                datas.weekSettingList[i].weekname =
                  datas.weekSettingList[i].weekName;
                datas.weekSettingList[i].datePickerValue = [
                  datas.weekSettingList[i].beginTime,
                  datas.weekSettingList[i].endTime,
                ];
                datas.weekSettingList[i].weekTarget =
                  datas.weekSettingList[i].week_target_list;
              }
            }

            this.datas = datas;
            // datas.shopSettingList[tab].shopWeekSetting
            datas.shopSettingList.forEach((item) => {
              this.weekData.push(item);
            });
            // console.log(this.weekData);
          }
        });
    },

    changeDatePickerValue(index,event) {
    
    },
    jia() {
      let len = this.datas.weekSettingList.length;
      this.datas.weekSettingList.push({
        weekName: "第" + this.$public.formatNumTochinese(len + 1) + "周",
        datePickerValue: ["", ""],
        week_name: "",
        begin_time: "",
        end_time: "",
      });
      this.weekData.forEach((item) => {
        item.shopWeekSetting.push({
          salePetMoney: "",
          saleGoodsMoney: "",
          saleMedicalMoney: "",
          saleWashMoney: "",
          saleMoney: "",
          salePetCount: "",
        });
      });
    },
    jian() {
      let len = this.datas.weekSettingList.length;
      this.datas.weekSettingList.splice(len - 1, 1);
      this.weekData.forEach((item) => {
        item.shopWeekSetting.splice(item.shopWeekSetting.length - 1, 1);
      });
    },
    inputMoney1(shop) {
      shop.month_rate = 0;
    },
    changeNum1(shop) {
      shop.month_target = this.$public.cheng(
        shop.last_month_performance,
        shop.month_rate / 100
      );
    },
    inputMoney2(shop) {
      shop.living_rate = 0;
    },
    changeNum2(shop) {
      shop.living_target = Math.ceil(
        this.$public.cheng(shop.last_living_performance, shop.living_rate / 100)
      );
    },
  },
};
</script>

<style scoped lang="scss">
ul {
  display: flex;
}

.drawer {
  width: 100%;
  padding: 0 0 0 0;

  .cell1 {
    width: 290px;
    display: flex;
    background: rgba(239, 210, 187, 0.5);
    border-radius: 10px;

    div {
      // border: 1px solid gray;
      padding: 10px 15px;
    }

    .active {
      background-color: $mainColor;
      color: #fff;
      border-color: $mainColor;
      font-size: 14px;
      border-radius: 8px;
      cursor: pointer;
    }
  }

  ::v-deep.el-drawer {
    .el-drawer__body {
      overflow-y: auto;
      padding-bottom: 30px;
    }
  }
}
.avatar {
  width: 220px;
  display: block;
  margin: 150px auto 80px;
}

.row {
  padding: 20px 20px 0;
  float: none;
  font-size: 20px;

  .label {
    display: inline-block;
    width: 150px;
    text-align: right;
    font-size: 14px;
    color: $fontColor;
    vertical-align: top;
  }
}
.value {
  display: inline-block;
  font-size: 14px;
  color: $fontColor;

  .table {
    border: 1px solid #e7e7e7;
    border-right: 0;
    border-bottom: 0;
    width: 1400px;
    margin-left: 10px;

    .tableRow {
      display: flex;
      border-bottom: 1px solid #e7e7e7;

      .cell {
        border-right: 1px solid #e7e7e7;
        height: 50px;
        width: 100%;
        text-align: center;
        padding: 8px 0;
        box-sizing: border-box;
        line-height: 32px;
      }
    }
  }
}
.btnBox {
  width: 100%;
  font-size: 14px;
  color: #fff;
  line-height: 40px;
  display: flex;
  position: absolute;
  bottom: 0;
  z-index: 10;

  .btnItem {
    text-align: center;
    width: 100%;
    background-color: #d6d6d6;
    cursor: pointer;

    &.submit {
      background-color: $mainColor;
    }
  }
}
</style>
